import { LIBELLES_STATUT, type StatutCandidature } from '@rh/shared';

/**
 * Statut d'une candidature en étiquette. « Écarté » ressort sur fond jaune
 * (demande du 2026-09-19) : c'est l'information qu'on cherche en parcourant
 * une liste, et elle accompagne le nom barré — la couleur ne va jamais seule.
 */
export function Statut({ valeur }: { valeur: StatutCandidature }) {
  return (
    <span className={`etiquette-statut${valeur === 'ecarte' ? ' etiquette-ecarte' : ''}`}>
      {LIBELLES_STATUT[valeur]}
    </span>
  );
}
